module.exports = __webpack_public_path__ + "img/w_mockup_frame.63755f24.png";